import React from 'react';

const StatsGrid = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
      {stats.map((stat, i) => (
        <div key={i} className="bg-white p-6 rounded-sm border-l-4 border-[#003366] shadow-sm">
          <div className="flex justify-between items-start mb-4">
            <div className="p-2 bg-slate-50 rounded-lg">
              <stat.icon className="w-5 h-5 text-[#cc0000]" />
            </div>
            <span className={`text-xs font-bold ${stat.trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
              {stat.change}
            </span>
          </div>
          <h3 className="text-slate-500 font-bold uppercase text-[10px] tracking-widest mb-1">{stat.label}</h3>
          <p className="text-2xl font-black text-slate-900">{stat.value}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
